import RaisedButton from 'material-ui/RaisedButton';
import React, {PropTypes} from 'react';

export default function CancelButton({disabled, onClick}) {
  return <RaisedButton disabled={disabled} onTouchTap={onClick}>Cancel</RaisedButton>;
}

CancelButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/features/shared/components/CancelButton.js